import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { broadcastApi, type BroadcastBannerSet } from "@/services/broadcastApi";

const QK = ["broadcast"];

export function useBroadcast() {
  return useQuery({
    queryKey: QK,
    queryFn: broadcastApi.get,
    staleTime: 30_000,
  });
}

export function useBroadcastAdmin() {
  const qc = useQueryClient();
  const invalidate = () => qc.invalidateQueries({ queryKey: QK });

  const set = useMutation({
    mutationFn: (data: BroadcastBannerSet) => broadcastApi.set(data),
    onSuccess: invalidate,
  });

  const hide = useMutation({
    mutationFn: broadcastApi.hide,
    onSuccess: invalidate,
  });

  return { set, hide };
}
